/**
 * PreviewTeam — Team members grid with photos/icons
 */
import { RenderIcon } from './RenderIcon';

interface TeamMember {
  name: string;
  role: string;
  bio: string;
  image?: string;
}

interface PreviewTeamProps {
  data: {
    title?: string;
    subtitle?: string;
    members?: TeamMember[];
  };
  settings: {
    [key: string]: any;
  };
}

export function PreviewTeam({ data, settings }: PreviewTeamProps) {
  return (
    <section className="preview-team" id="team">
      <div className="preview-container">
        <div className="preview-section-header">
          <h2>{data.title}</h2>
          <p>{data.subtitle}</p>
        </div>

        <div className="preview-team__grid">
          {data.members?.map((member, i) => (
            <div key={i} className="preview-team-member">
              <div className="preview-team-member__image">
                {member.image ? (
                  <img src={member.image} alt={member.name} />
                ) : (
                  <RenderIcon name="users" />
                )}
              </div>
              <h4>{member.name}</h4>
              <p className="preview-team-member__role">{member.role}</p>
              <p className="preview-team-member__bio">{member.bio}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
